












































































import { useRouter, useStore } from '@/hooks/common'
import { Message } from '@heytap/cook-ui'
import { createComponent, ref, onMounted, watch, computed } from '@vue/composition-api'
import { MessageBox } from 'element-ui'
import { getDuplicateData, IFileItem, IFileRes, multiCopy, multiMove } from '../service/public'
export interface TargetDirType {
    name: string
    id: string
}
export interface StartCheckType {
    list: IFileItem[]
    currentDirId: string
    target: TargetDirType
}
export default createComponent({
    name: 'DuplicateNameConfirm',
    props: {
        isDrag: {
            type: Boolean,
            default: false,
        },
        boxType: {
            type: String,
            default: () => 'move',
        },
    },
    setup(props, { emit }) {
        const fileList = ref<IFileItem[]>([])
        const duplicateData = ref<IFileItem[]>([])
        const repeatDialogVisible = ref(false)
        const targetDir = ref<TargetDirType>({})
        const boxTypeTxt = computed(() => {
            return props.boxType === 'move' ? '移动' : '复制'
        })
        // const repeatHandleType = ref(0);
        // const isFolder = computed(() => !duplicateData.value[0].isFile);

        const cancelHandle = () => {
            repeatDialogVisible.value = false
            fileList.value = []
            duplicateData.value = []
        }
        const post = async () => {
            // TODO 1接口移动文件
            const ids = fileList.value.map(file => {
                return file.id
            })
            const params = {
                ids,
                userId: (window as any).userId,
                target: targetDir.value.id,
            }
            try {
                let res: IFileRes
                if (props.boxType === 'move') {
                    res = await multiMove(params)
                } else {
                    res = await multiCopy(params)
                }
                if (res.code === 0) {
                    repeatDialogVisible.value = false
                    Message.success('操作成功')
                    emit('on-move-success')
                } else {
                    Message.error(res.desc)
                }
            } catch (error) {
                console.log(error)
            }
        }
        const checkFile = async () => {
            // 分别检查文件名和文件夹是否有重名
            const fileData = fileList.value.filter(file => {
                return file.isFile
            })
            const folderList = fileList.value.filter(file => {
                return !file.isFile
            })
            let requestList: Promise<IFileRes>[] = []
            if (fileData.length > 0) {
                const fileNames = fileData.map(file => {
                    return file.name
                })
                const fileParams = {
                    names: fileNames,
                    dirId: targetDir.value.id,
                    userId: (window as any).userId,
                    file: true,
                }
                requestList.push(getDuplicateData(fileParams))
            }
            if (folderList.length > 0) {
                const folderNames = folderList.map(folder => {
                    return folder.name
                })
                const folderParams = {
                    names: folderNames,
                    dirId: targetDir.value.id,
                    userId: (window as any).userId,
                    file: false,
                }
                requestList.push(getDuplicateData(folderParams))
            }
            const res = await Promise.all(requestList)
            let duplicateData: IFileItem[] = []
            res.map(item => {
                if (item.code === 0) {
                    if (item.data.length > 0) {
                        duplicateData = [...duplicateData, ...(item.data as IFileItem[])]
                    }
                } else {
                    Message.error(item.data as string)
                }
            })
            return duplicateData
        }
        const startCheck = async ({ list, currentDirId, target }: StartCheckType) => {
            fileList.value = list
            targetDir.value = target
            const fileName = fileList.value.map(file => file.name)
            if (props.isDrag) {
                try {
                    await MessageBox.confirm(
                        `请确认将文件${boxTypeTxt.value}至‘${targetDir.value.name}’文件夹内`,
                        `文件${boxTypeTxt.value}`,
                        {
                            cancelButtonText: '取消',
                            confirmButtonText: '确认',
                        }
                    )
                } catch (error) {
                    // 取消移动
                    console.log(error)
                    return false
                }
            }
            duplicateData.value = await checkFile()
            if (duplicateData.value.length > 0) {
                repeatDialogVisible.value = true
            } else {
                post()
            }
        }

        return {
            duplicateData,
            repeatDialogVisible,
            // repeatHandleType,
            // isFolder,
            cancelHandle,
            startCheck,
            post,
        }
    },
})
